import React from 'react';
import { FaSmile, FaAngry, FaSkull } from 'react-icons/fa';
import { Col, Row } from 'antd';
import { ButtonToolTip, CardTheme, TextSmall } from '../../../components';
import { IconContainerDiv, StatusColumnContainer } from '../../../styles/global-style';
import { color } from '../../../resources';

// เกณฑ์เดียวกันทั้งไอคอนต่อแถวและคำอธิบายในกรอบ: 1-2 ยิ้ม, 3-4 โมโห, 5 ขึ้นไปกะโหลก
const getClaimCountIcon = (count) => {
  if (count >= 5) return { CountIcon: FaSkull, iconColor: color.red2 };
  if (count >= 3) return { CountIcon: FaAngry, iconColor: color.orangeTheme };
  if (count >= 1) return { CountIcon: FaSmile, iconColor: color.line };
  return null;
};

export const ClaimCountIcon = ({ warrantyClaimCount, onClick }) => {
  const count = Number(warrantyClaimCount) || 0;
  const matched = getClaimCountIcon(count);
  if (!matched) return null;
  const { CountIcon, iconColor } = matched;
  return (
    <ButtonToolTip toolTip={`ใช้เคลมไปแล้ว ${count} ครั้ง (ไม่นับยกเลิก/ไม่อนุมัติ)`}>
      <span
        style={{
          color: iconColor,
          display: 'inline-flex',
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={(event) => {
          if (!onClick) return;
          event.stopPropagation();
          onClick();
        }}
      >
        <CountIcon />
      </span>
    </ButtonToolTip>
  );
};

const LEGEND_ITEMS = [
  { key: 'smile', Icon: FaSmile, iconColor: color.line, label: '1-2 ครั้ง' },
  { key: 'angry', Icon: FaAngry, iconColor: color.orangeTheme, label: '3-4 ครั้ง' },
  { key: 'skull', Icon: FaSkull, iconColor: color.red2, label: '5 ครั้งขึ้นไป' },
];

// คำอธิบายไอคอนจำนวนเคลม รูปแบบเดียวกับกล่อง สถานะ / สถานะภายใน ของหน้าเคลม
// framed=false ใช้เมื่อวางไว้ในกรอบที่มีอยู่แล้ว (หน้าเคลม) หน้าที่ไม่มีกรอบสถานะให้ครอบ CardTheme เอง
export const ClaimCountLegend = ({ framed = true }) => {
  const content = (
    <>
      <TextSmall bold style={{ textDecoration: 'underline' }}>
        จำนวนเคลม
      </TextSmall>
      <Row align="middle" gutter={16} style={{ marginTop: '3px', marginBottom: '3px' }}>
        {LEGEND_ITEMS.map(({ key, Icon, iconColor, label }) => (
          <Col key={key}>
            <StatusColumnContainer>
              <IconContainerDiv style={{ color: iconColor }}>
                <Icon />
              </IconContainerDiv>
              <TextSmall>&nbsp;{label}</TextSmall>
            </StatusColumnContainer>
          </Col>
        ))}
      </Row>
    </>
  );
  if (!framed) return content;
  return <CardTheme style={{ marginBottom: 16 }}>{content}</CardTheme>;
};
